<script>
    import { BaseEdge, EdgeLabel, getBezierPath } from "@xyflow/svelte";

    let {
        id,
        sourceX,
        sourceY,
        targetX,
        targetY,
        sourcePosition,
        targetPosition,
        markerEnd,
        style,
        selected,
        label,
        data,
    } = $props();

    const route = $derived.by(() => {
        const [path, labelX, labelY] = getBezierPath({
            sourceX,
            sourceY,
            sourcePosition,
            targetX,
            targetY,
            targetPosition,
        });

        return {
            path,
            labelX: labelX + Number(data?.labelOffsetX ?? 0),
            labelY: labelY + Number(data?.labelOffsetY ?? 0),
        };
    });
</script>

<BaseEdge
    {id}
    path={route.path}
    {markerEnd}
    {style}
    class={selected ? "selected" : undefined}
/>
{#if label}
    <EdgeLabel x={route.labelX} y={route.labelY}>
        <div class="research-edge-label" class:selected>{label}</div>
    </EdgeLabel>
{/if}

<style>
    .research-edge-label {
        pointer-events: none;
        padding: 2px 7px;
        border: 1px solid rgba(113, 113, 122, 0.25);
        border-radius: 999px;
        background: color-mix(in srgb, canvas 94%, transparent);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        color: #52525b;
        font-size: 10px;
        font-weight: 650;
        line-height: 16px;
        white-space: nowrap;
        backdrop-filter: blur(6px);
    }
    .research-edge-label.selected {
        border-color: #6366f1;
        color: #4f46e5;
    }
    :global(.dark) .research-edge-label {
        border-color: rgba(255, 255, 255, 0.14);
        background: rgba(24, 24, 27, 0.92);
        color: #d4d4d8;
    }
</style>
